module.exports = __webpack_public_path__ + "static/media/lu.ec7af974.webp";